import React from 'react'

import { ImageList } from '../components/ImageList'

export default class Index extends React.Component {
  render() {
    return (
      <div
        style={{
          borderLeft: '1px solid #CCCCFF',
          borderTop: '1px solid #CCCCFF',
          padding: 75,
          height: 690
        }}
      >
        <img style={{height: 176, width: 315}} src='/assets/quebec-photos/1.jpg' />

        <ImageList />

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./images.js